
export default function NotFound() {
  return (
      <>
        <h1> OUPS ! 404 Not Found</h1>
      </>
  )
}